import * as z from 'zod/mini';

const envelopeSchema = z.object({ data: z.unknown() });

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

type TokenSource = () => Promise<string | undefined>;

let accessToken: TokenSource | null = null;

export const setAccessToken = (source: TokenSource | null) => {
  accessToken = source;
};

const headers = async () => {
  const token = await accessToken?.();

  return { accept: 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}) };
};

export const getData = async <Schema extends z.ZodMiniType>(path: string, schema: Schema): Promise<z.infer<Schema>> => {
  const response = await fetch(`/api${path}`, { headers: await headers() });

  if (!response.ok) {
    throw new ApiError(response.status, `GET /api${path} answered ${response.status}`);
  }

  return schema.parse(envelopeSchema.parse(await response.json()).data);
};

const sendJson =
  (method: 'POST' | 'PUT') =>
  async <Schema extends z.ZodMiniType>(path: string, body: unknown, schema: Schema): Promise<z.infer<Schema>> => {
    const response = await fetch(`/api${path}`, {
      method,
      headers: { ...(await headers()), 'content-type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new ApiError(response.status, `${method} /api${path} answered ${response.status}`);
    }

    return schema.parse(envelopeSchema.parse(await response.json()).data);
  };

export const postData = sendJson('POST');

export const putData = sendJson('PUT');

export const getAudio = async (path: string) => {
  const response = await fetch(`/api${path}`, { headers: await headers() });

  if (!response.ok) {
    throw new ApiError(response.status, `GET /api${path} answered ${response.status}`);
  }

  return response.blob();
};
